import React from "react";
import { NotificationModalProvider } from "./src/context/NotificationContext";
import "./src/styles/global.css";
import InAppNotificationModal from "./src/components/interface/Modals/InAppNotificationModal";

export const wrapPageElement = ({ element }) => {
  return (
    <NotificationModalProvider>
      {element}

      <InAppNotificationModal />
    </NotificationModalProvider>
  );
};
